// const currentHost = new URL(document.location).hostname.replace(/^www\./, '')

for (const element of document.querySelectorAll('.n-iframe iframe')) {
  const src = element.dataset.src
  const message = element.dataset.message
  if (src) {
    const vendor = new URL(src).hostname
      .replace(/^www\./, '')
      .replace(/\.com|\.fr$/, '')
    const vendorName = vendor[0].toUpperCase() + vendor.slice(1)

    element.dataset.requiresVendorConsent = vendor
    const consentPanel = document.createElement('div')
    consentPanel.classList.add('cookie-managment')
    consentPanel.dataset.hideOnVendorConsent = vendor

    const consentButton = document.createElement('button')
    consentButton.type = 'button'
    consentButton.classList.add('button', '--primary')
    consentButton.innerHTML = message.replace('@provider', vendorName)
    consentButton.addEventListener('click', () =>
      window?.axeptioSDK?.requestConsent(vendor),
    )
    consentPanel.appendChild(consentButton)
    element.parentElement.appendChild(consentPanel)
  }
}
